import QueryString from 'qs'
import { apiClient } from '../client'
import { PageListParams } from '../globalTypes'
import { FormSubmission } from './types'

export const getFormsSubmission = async (id: string, payload: PageListParams) => {
    const response = await apiClient(`v1/form-submission/contact/${id}`, {
        params: payload,
        paramsSerializer: (params: PageListParams) => {
            return QueryString.stringify(params)
        },
    })

    return response.data
}

export const getFormSubmissionById = async (id: string) => {
    if (id) {
        const response = await apiClient(`v1/form-submission/${id}`)

        return response.data
    } else {
        return []
    }
}

export const getFormById = async (id: string) => {
    const response = await apiClient(`v1/form/${id}`)
    return response.data
}

export const createUpdateFormsSubmissions = async (data: FormSubmission, fromSubmissionId?: string, isEdit?: boolean) => {
    const url = isEdit ? `v1/form-submission/${fromSubmissionId}` : `v1/form-submission`

    const response = await apiClient(url, {
        method: isEdit ? 'PUT' : 'POST',
        data: data,
    })

    return response.data
}

export const getCompanyAssociateById = async (companyId: string, payload: PageListParams) => {
    const response = await apiClient(`v1/contact/company/${companyId}/associates`, {
        params: payload,
        paramsSerializer: (params: PageListParams) => {
            return QueryString.stringify(params)
        },
    })

    return response.data
}

export const getAnalysisPdf = async (id: string | undefined) => {
    const response = await apiClient(`v1/form-submission/${id}/pdf`)

    const byteCharacters = atob(response.data.pdf_base64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const pdfBlob = new Blob([byteArray], { type: 'application/pdf' })
    const pdfBlobUrl = URL.createObjectURL(pdfBlob)

    return pdfBlobUrl
}
